var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tags_container"},_vm._l((_vm.tagsOfFilters),function(tag,index){return _c('div',{key:index},[(tag.status == true)?_c('div',{},[_c('FilterTagsEmployee',{attrs:{"index":index,"id":tag.id,"tag":tag.name,"status":tag.status}})],1):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }